module.exports = __webpack_public_path__ + "static/media/parts_22.1f26dc09.svg";